import React, {useContext} from "react";
import {UserContext} from "@front-component";
import {BrandProtectionEdit} from "@front-component";

export function BrandProtectionEditPage({selectedProtectionId}) {
    const {user, setUser} = useContext(UserContext)
    return <BrandProtectionEdit selectedProtectionId={selectedProtectionId} customerId={user?.account?.googleCustomerId}/>
}
